import { Link } from "react-router-dom";
import utbProg from "../../app/assets/images/utbildningar-och-program-ris-utan-laenkar-kopiera.jpg";

function Page() {
  return (
    <div className="vanligsida col-sm-10">
      <h1>Inspirationsföreläsningar och erfarenhetsutbyte</h1>
      <span className="ingress">
        Rörlighet i staten erbjuder digitala inspirationsföreläsningar och
        digitala erfarenhetsutbyte, så kallade popup-samtal för alla medarbetare
        oavsett roll i myndigheter som är medlemmar i Rörlighet i staten.
      </span>
      <br />
      <br />
      <br />
      <br />
      <h2>Inspirationsföreläsningar</h2>
      <br />
      <h5>Föreläsningsprogrammet läggs ut på webbsidan inom kort.</h5>
      <br />
      <br />
      <br />
      <h2>Digitalt erfarenhetsutbyte - popup-samtal</h2>
      <p>
        <span>
          Rörlighet i statens popup-samtal är digitala erfarenhetsutbyten kring
          en aktuell fråga. Samtalet leds av en facilitator och inleds med en
          introduktion av temat, därefter läggs största tiden på utbyte mellan
          deltagarna. Målgruppen är medarbetare inom myndigheter i Rörlighet i
          staten.
          <br />
        </span>
        <br />
        <br />
        <h4>
          Erfarenhetsutbyte: Hur jobba med förändring när myndigheter slås ihop
          – Rörlighet i staten
        </h4>
        <span>
          Dokumentation från erfarenhetsutbytet
          <br />
          2024 4 okt kl 9-11 via Zoom
        </span>
        <br />
        <Link to="/inspirationsforelasningar-och-samtal/erfarenhetsutbyte-hur-jobba-med-forandring-nar-myndigheter-slas-ihop/">
          Läs mer
        </Link>
        <br />
        <br />
        <h4>Erfarenhetsutbyte om desinformation – Rörlighet i staten</h4>
        <span>
          Dokumentation Popup-samtal om desinformation
          <br />
          2024 31 maj kl 9-11
        </span>
        <br />
        <Link to="/inspirationsforelasningar-och-samtal/erfarenhetsutbyte-om-desinformation/">
          Läs mer
        </Link>
      </p>
      <p>&nbsp;</p>
      <h4>Har du tips på ämnen?</h4>
      <p>
        <span></span>
        <span>
          Har du förslag till ett aktuellt ämne som vi kan ta upp vid nästa
          popup-samtal? Skicka förslaget till Christina Frimodig,
          christina.frimodig@naturvardsverket.se
          <br />
        </span>
      </p>
      <div>
        <p>
          Har du frågor kontakta Cecilia Carenfelt, Statens Historiska Museer.
          Förnamn.efternamn@shm.se
        </p>
      </div>
      <p>&nbsp;</p>

      <div className="umb-grid">
        <div className="grid-section">
          <div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Page;
